<template>
  <h1 class="officehome-gnb-hiworks">
    <a :href="logoPath" :title="$t('오피스')">
      <ShortHiworksLogo v-if="viewType === 'mobile'" />
      <HiworksLogo v-else />
    </a>
  </h1>
</template>

<script>
import { mapState } from 'vuex';
import HiworksLogo from '@/components/Icon/HiworksLogo.vue';
import { VIEW_TYPE } from '@/constants/index.ts';
import ShortHiworksLogo from '@/components/Icon/ShortHiworksLogo.vue';

export default {
  name: 'LinkedHwLogo',
  props: {
    viewType: {
      type: String,
      default: VIEW_TYPE.DESKTOP,
    },
  },
  components: {
    HiworksLogo,
    ShortHiworksLogo,
  },
  computed: {
    ...mapState({
      cacheOfficeInfo: (state) => state.cache.officeInfo,
    }),
    logoPath() {
      // office 정보를 못가져올 경우 현재 url return
      if (this.cacheOfficeInfo.office && this.cacheOfficeInfo.office.office_id) {
        return process.env.VUE_APP_OFFICE_URL + '/' + this.cacheOfficeInfo.office.office_id;
      }
      return location.href;
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  display: block;
  line-height: 0;
}
</style>
